import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Stack,
  LinearProgress,
} from '@mui/material';

interface LoadingProps {
  variant?: 'circular' | 'linear' | 'page';
  size?: 'small' | 'medium' | 'large';
  message?: string;
  progress?: number; // For linear progress
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  variant = 'circular',
  size = 'medium',
  message,
  progress,
  fullScreen = false,
}) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return 24;
      case 'large':
        return 64;
      default:
        return 40;
    }
  };

  const renderLoading = () => {
    switch (variant) {
      case 'linear':
        return (
          <Box sx={{ width: '100%', mb: 2 }}>
            <LinearProgress 
              variant={progress !== undefined ? 'determinate' : 'indeterminate'}
              value={progress}
            />
            {message && (
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ mt: 1, textAlign: 'center' }}
              >
                {message}
              </Typography>
            )}
          </Box>
        );
      
      case 'page':
        return (
          <Stack
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: fullScreen ? '100vh' : '200px',
              width: '100%',
            }}
          >
            <CircularProgress size={getSize()} />
            {message && (
              <Typography variant="body1" color="text.secondary">
                {message}
              </Typography>
            )}
          </Stack>
        );
      
      default: // circular
        return (
          <Stack spacing={1} alignItems="center">
            <CircularProgress size={getSize()} />
            {message && (
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ textAlign: 'center' }}
              >
                {message}
              </Typography>
            )}
          </Stack>
        );
    }
  };

  if (fullScreen && variant === 'page') {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'background.default',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {renderLoading()}
      </Box>
    );
  }

  return <Box>{renderLoading()}</Box>;
};

export default Loading;